//
//
//
//
//
//

import DialogBox from './dialogBox.vue';
const lodash = window._;
import axios from 'axios';


export const getFileNameExt = (filename) => {
    let fileName = filename.lastIndexOf(".");
    let fileNameLength = filename.length;
    return filename.substring(fileName + 1, fileNameLength).toUpperCase();
}

export default {
    components: {
        DialogBox
    },
    props: {
        slotComponent: {
            default: 'div',
        },
        limitSize: {
            default: 10 * 1024 * 1024,
        },
        typeLimit: {
            type: Array,
            default() {
                return ['JPG', 'JPEG', 'PNG']
            },
        },
        accept: {
            type: String,
            default: '*',
        },
        typeErrTip: {
            type: String,
            default: '格式错误',
        },
        loadTip: {
            type: String,
            default: '上传中',
        },
        errTip: {
            type: String,
            default: '上传失败',
        },
    },
    computed: {

    },
    data() {
        return {
            isUploading: false
        }
    },
    mounted() {},
    methods: {
        startUpload() {
            if (this.isUploading) {
                top.$.alertTip('还有文件上传中，请稍等');
                return;
            }
            let div = document.createElement('div');
            div.style.position='absolute';
            div.style.left=0;
            div.style.top=0;
            div.style.width=0;
            div.style.height=0;
            div.style.overflow='hidden';

            document.body.appendChild(div);
            div.innerHTML = `<form action=""><input style="font-size:999px" accept="${this.accept}" type="file" /></form>`;

            let form = div.childNodes[0];
            let input = form.childNodes[0];
            const vm = this;
            $(input).off('change').on('change',function(e){
                let files = this.files;
                if(files.length){
                    const file = files[0]
                    if(file['size']*1 > vm.limitSize) {
                        top.$.alertTip('文件不能大于'+Util.File.ShowSize(vm.limitSize,0));
                        return false;
                    }
                    if (vm.typeLimit) {
                        const diff = getFileNameExt(file.name);
                        if (vm.typeLimit.indexOf(diff) == -1) {
                            top.$.alertTip(vm.typeErrTip);
                            return false;
                        }
                    }
                    vm.doUpload(files[0]);
                } else {
                    try {
                        $.alertTip('请选择文件');
                    } catch (e) {
                    }
                }
                form.reset();
            })
            input.click();
        },
        doUpload(file){
            if (this.loadTip) $.loadTip(this.loadTip)
            this.isUploading = true;
            // 创建 FormData 对象
            const formData = new FormData();
            const customAxios = axios.create({
                withCredentials: true
            });
            formData.append('image', file); // 将文件添加到 FormData 的 'image' 字段
            // 发送 POST 请求
            customAxios.post(`//passportapi.115.com/app/1.0/web/1.0/user/safeUploadImage`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data' // 设置请求头
                }
            }).then(response => {
                $.closeTip();
                this.isUploading = false
                const resp = response.data || {};
                if (resp.state) {
                    this.$emit('success', resp.data);
                } else {
                    $.alertTip(resp.message);
                }
            })
            .catch(error => {
                this.isUploading = false
                $.alertTip('网络异常，请重试' );
                console.log(error.response ? error.response.message : error.message);
            });
        },
    }
}
